export default "__VITE_ASSET__BZWk7wkS__"